module.exports = __webpack_public_path__ + "img/COWBOY-LION.98ea2809.jpg";